import React, { Component } from 'react';

class Combo extends Component {
    
    render() {
        const { infoData, nombreAction, selectCombo, selecciones, placeholder,titulo,id} = this.props
        
        let black = false
        let firstOption = {Id:0,Descripcion: placeholder == "Todos" ? placeholder : "Seleccione " + placeholder}        
        if(selecciones[nombreAction] == firstOption.Id) black = true

        return (
            <div className='right-padding-s'>
                <div className='robotoTitulo bottom-separator-xs'>{titulo}</div>
                <select id={id} className={"comboBajaCuenta "}  style={ black ? {color:"black"} : null} value={selecciones[nombreAction]} onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo(nombreAction, value ) 
                }}>
                    <option  key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option> 
                    {infoData.length>0 && infoData.map( (item,index) => {return <option style={{color:"black"}} key={index} value={item.Id}>{item.Descripcion ? item.Descripcion : item.DescripcionProceso}</option>} )}}
                </select>
            </div>
        );
    }
}

export default Combo;